import * as React from "react";

interface IProps {
  title: string;
  submit_remoderation: number;
  delete_remoderation: number;
}
export default class RemoderationActivityRow extends React.Component<IProps> {
  public render() {
    const {
      title,
      submit_remoderation: submitted,
      delete_remoderation: deleted
    } = this.props;

    return (
      <tr>
        <td>{title}</td>
        <td>{submitted}</td>
        <td>{deleted}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Remoderation/RemoderationActivityRow.tsx